import { useAppDispatch, useAppSelector } from 'src/store';
import useCustomer from 'src/app/customers/hooks/useCustomer';
// import { useLazySurveyDesignsQuery } from 'src/app/surveys/state/api/surveyGraphSlice';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { getCurrentHabitatInsightsUploadFormState } from 'src/app/habitat-insights/state/habitatInsightsUploadSelector';
import {
    useHabitatInsightsUploadMutation,
    useCreateProjectInfoMutation,
    useLazyHabitatInsightsProjectsQuery,
} from 'src/app/habitat-insights/state/api/habitatInsightsUploadGraphSlice';
import { HabitatInsightsUploadFormState, setFormState } from 'src/app/habitat-insights/state/habitatInsightsUploadSlice';

const useSurveyDesign = () => {
    const formState = useAppSelector(getCurrentHabitatInsightsUploadFormState);
    const { currentCustomerId } = useCustomer();
    const dispatch = useAppDispatch();
    const navigate = useAppNavigation();

    const onFormChange = (fragment: Partial<HabitatInsightsUploadFormState>) => {
        dispatch(
            setFormState({
                ...fragment,
            })
        );
    };

    const { sites } = formState;

    const enableUpload = formState.projectId;

    const [habitatInsightsUpload] = useHabitatInsightsUploadMutation();
    const [createProjectInfo] = useCreateProjectInfoMutation();
    const [fetchHabitatInsightsProjects] = useLazyHabitatInsightsProjectsQuery();

    const submitHabitatInsightsUploadForm = async () => {
        let response;
        try {
            response = await habitatInsightsUpload({
                projectId: formState.projectId || '',
                customerId: currentCustomerId,
                sites,
            }).unwrap();
        } catch (error) {
            console.error('rejected', error);
        } finally {
            await fetchHabitatInsightsProjects({
                customerId: currentCustomerId,
            }).unwrap();
            onFormChange({ loading: false });
            if (response) {
                navigate.toHabitatInsightsAdmin();
            }
        }
    };

    const submitProjectInfo = async () => {
        try {
            return await createProjectInfo({
                customerId: currentCustomerId,
                projectId: formState.projectId || '',
                projectName: formState.projectName || '',
                projectCode: formState.projectId || '',
                subscriptionType: formState.subscriptionType || '',
                country: formState.country || '',
                leadName: formState.leadName || '',
                leadEmail: formState.leadEmail || '',
                leadRole: formState.leadRole || '',
            }).unwrap();
        } catch (error) {
            console.error('rejected', error);
        }
    };

    return {
        submitHabitatInsightsUploadForm,
        onFormChange,
        formState,
        enableUpload,
        submitProjectInfo,
    };
};

export default useSurveyDesign;
